import { generateParams } from "@/utils/helper/generateParams";
import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";

async function getContracts(queryFunctionContext: QueryFunctionContext) {
  const { queryKey } = queryFunctionContext;
  const [_, contractsQueryKey] = queryKey;
  const { servcoName, contractName } = contractsQueryKey as {
    servcoName: string;
    contractName: string;
  };

  const params = {
    servcoName,
    contractName,
  };

  const response = await axiosInstance.get(
    `/e2e/hpm/contract-servco${generateParams(params)}`,
  );

  return response.data.data;
}

function useContracts(
  contractsQueryKey: { servcoName: string; contractName: string },
  options?: {
    enabled?: boolean;
  },
) {
  return useQuery({
    ...options,
    queryKey: ["contract-servcos", contractsQueryKey],
    queryFn: getContracts,
  });
}
export { useContracts };
